import { PurchaseorderDataForm, PurchaseOrderFilters } from '../../../../app/models/PurchaseOrder';
import ButtonTableAction from '../../../../components/buttons/ButtonTableAction';
import DefaultDataTable from '../../../../components/default/DefaultDataTable';

import { momentParseDate } from '../../../../helpers';
import { formatMoney } from '../../../../utils/utils';

import React from 'react';
import PurchaseOrderFilter from './PurchaseOrderFilter';

interface Props {
    purchaseOrders: PurchaseorderDataForm[];
    totalRows: number;
    loading?: boolean;
    edit?: (id: number) => void;
    show?: (id: number) => void;
    destroy?: (id: number) => void;
    filter: PurchaseOrderFilters;
    setFilter: (filter: PurchaseOrderFilters) => void;

    paginationRowsPerPageOptions?: any[];
}

const PurchaseOrderDataTable = ({
    purchaseOrders,
    totalRows,
    loading = false,
    edit,
    destroy,
    show,
    filter,
    setFilter
}: Props) => {
    const columns = [
        {
            name: 'Id',
            selector: (row: any) => row?.id,
            sortable: true,
            sortField: 'id',
            width: '70px',
            cell: (row: PurchaseorderDataForm) => (
                <span style={{ whiteSpace: 'nowrap' }}>#{row?.id}</span>
            )
        },
        {
            name: 'RUT Sociedad',
            selector: (row: any) => row?.society_rut,
            sortable: false,
            width: '140px',
            cell: (row: PurchaseorderDataForm) => (
                <span style={{ whiteSpace: 'nowrap' }}>{row.society_rut || '—'}</span>
            )
        },
        {
            name: 'Sociedad',
            selector: (row: any) => row?.society,
            sortable: true,
            sortField: 'society',
            width: '220px',
            cell: (row: PurchaseorderDataForm) => (
                <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', display: 'block', maxWidth: '215px' }}>
                    {row.society || '—'}
                </span>
            )
        },
        {
            name: 'RUT Proveedor',
            selector: (row: any) => row?.provider_rut,
            sortable: false,
            width: '140px',
            cell: (row: PurchaseorderDataForm) => (
                <span style={{ whiteSpace: 'nowrap' }}>{row.provider_rut || '—'}</span>
            )
        },
        {
            name: 'Proveedor',
            selector: (row: any) => row?.provider,
            sortable: true,
            sortField: 'provider',
            width: '280px',
            cell: (row: PurchaseorderDataForm) => (
                <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', display: 'block', maxWidth: '275px' }}>
                    {row.provider || '—'}
                </span>
            )
        },
        {
            name: 'Estado',
            selector: (row: any) => row?.status,
            sortable: true,
            sortField: 'status',
            width: '130px',
            cell: (row: PurchaseorderDataForm) => (
                <span style={{ whiteSpace: 'nowrap' }}>{row?.status}</span>
            )
        },
        {
            name: 'Valor Neto',
            selector: (row: any) => row?.gross_total_calculated,
            sortable: false,
            width: '140px',
            cell: (row: PurchaseorderDataForm) => (
                <span style={{ display: 'block', textAlign: 'right', width: '100%', whiteSpace: 'nowrap' }}>
                    {row.gross_total_calculated !== null
                        ? formatMoney(row.gross_total_calculated ?? 0, row.currency, true)
                        : '—'}
                </span>
            )
        },
        {
            name: 'Moneda',
            selector: (row: any) => row?.currency,
            sortable: false,
            width: '90px',
            cell: (row: PurchaseorderDataForm) => (
                <span style={{ whiteSpace: 'nowrap' }}>{row.currency || '—'}</span>
            )
        },
        {
            name: 'Creado',
            selector: (row: any) => row?.created_at,
            sortable: true,
            sortField: 'created_at',
            width: '110px',
            cell: (row: PurchaseorderDataForm) => (
                <span style={{ whiteSpace: 'nowrap' }}>{momentParseDate(row?.created_at)}</span>
            )
        },
        {
            name: 'Acciones',
            selector: (row: any) => row?.id,
            sortable: false,
            width: '140px',
            cell: (row: PurchaseorderDataForm) => (
                <div className="">
                    {show && (
                        <ButtonTableAction
                            callbackFunction={() => show(row?.id ?? -1)}
                            classIcon={'mdi mdi-eye'}
                            colorIcon={'text-info'}
                            errorMessage={'No se puede mostrar este registro.'}
                            title={'Ver'}
                        />
                    )}
                    {edit && (
                        <ButtonTableAction
                            callbackFunction={() => edit(row?.id ?? -1)}
                            classIcon={'mdi mdi-pencil'}
                            colorIcon={'text-warning'}
                            errorMessage={'No se puede editar este registro.'}
                            title={'Editar'}
                        />
                    )}
                    {destroy && (
                        <ButtonTableAction
                            callbackFunction={() => destroy(row?.id ?? -1)}
                            classIcon={'mdi mdi-delete'}
                            colorIcon={'text-danger'}
                            errorMessage={'No se puede eliminar este registro.'}
                            title={'Eliminar'}
                        />
                    )}
                </div>
            )
        }
    ];

    return (
        <>
            <div className="row mt-3">
                <div className="col">
                    <PurchaseOrderFilter filter={filter} setFilter={setFilter} />
                </div>
            </div>

            <DefaultDataTable
                columns={columns}
                data={purchaseOrders}
                progressPending={loading}
                paginationTotalRows={totalRows}
                filter={filter}
                setFilter={setFilter}
            />
        </>
    );
};

export default PurchaseOrderDataTable;
